export const MENU_WIDTH = 420;

export const ACTION = {
  addBrandBrief: 'add_brand_brief',
};
